import { CSSObject } from '@chakra-ui/react';
import { CustomButtonProps } from '@/components/Button/Button';

export const buttonTakeBreakProps: CustomButtonProps = {
  variant: 'solid',
  lineHeight: 'normal',
  h: '38px',
};

export const ListItemExclusionItem: CSSObject = {
  fontSize: 'xs',
};

export const HeadingInformation: CSSObject = {
  color: 'alpha.700',
  fontWeight: 'medium',
  mb: '0',
  fontSize: 'sm',
};

export const TextInformation: CSSObject = {
  fontSize: 'xs',
  mb: '3',
  color: 'gray.700',
  '&:first-of-type': {
    fontWeight: 'medium',
  },
};

export const BoxStyledLink: CSSObject = {
  color: 'beta.500',
  textDecoration: 'underline',
};

export const TextM: CSSObject = {
  fontSize: 'sm',
  color: 'alpha.700',
  fontWeight: 'medium',
  mb: '0',
};

export const TextS: CSSObject = {
  fontWeight: 'medium',
  color: 'gray.700',
  fontSize: 'xs',
  '&:first-of-type': {
    mb: '2',
  },
};

export const BoxTakeABreak: CSSObject = {
  pb: '0',
  border: 'none',
};

export const TextDate: CSSObject = {
  fontSize: 'md',
  color: 'gray.700',
};

export const TextDateLabel: CSSObject = {
  color: 'alpha.700',
  fontSize: 'sm',
  fontWeight: 'medium',
};

export const TextConfirmBreak: CSSObject = {
  fontSize: 'xs',
  fontWeight: 'medium',
};

export const buttonConfirmBreakProps: CustomButtonProps = {
  height: '38px',
  variant: 'solid',
};

export const BoxTakeABreakWrapper: CSSObject = {
  borderBottom: 'none',
  pb: '0',
};
